export const trimTrailingSlashes = (value) => {
    return value.replace(/\/+$/, '');
};
